import { setClassName } from '@change-corgi/core/error';

import { HttpError } from './HttpError';

export class GoneError extends HttpError {
	constructor(options?: { cause?: unknown }) {
		super('Gone', 410, 410, options);
	}
}
setClassName(GoneError, 'GoneError');
